import { about_img_2, about_us, project_2, service_1, service_levelcrosing } from "../Materials/images";

export default function ProjectsPage(){
    return (
        <div className="projects-container">

        <section className="hero">
            <div className= "hero-background"></div>
            <div className="hero-text hero-card">
                <h1>Project Experience</h1>
            </div>
        </section>
        <section className="projects">
            <div class="card">
                <div class="img-container">
                    <img src={about_us} alt="service"/>
                </div>
                <div class="card-content">  
                    <p>InfraWorks Turnkey Projects, despite its recent 
                        establishment, demonstrates significant proficiency in 
                        securing and effectively overseeing the contract for the 
                        municipality’s network of six rail freight sidings. These 
                        sidings cover approximately 60 kilometers and 
                        strategically support the Industrial Area. Our 
                        responsibilities extended beyond mere management to 
                        include obtaining approval for a new Railway Operating 
                        Permit from the Railway Safety Regulator (RSR) using the 
                        Safety Permit Conformity Assessment Methodology 
                        (SPCAM) and overseeing the maintenance contractor.
                    </p>
                </div>
            </div>

            <div class="card">
                <div class="img-container">
                    <img src={project_2} alt="service"/>
                </div>
                <div class="card-content">  
                    <p>
                        Our company has extensive experience in implementing 
                        advanced railway security technology within state-owned 
                        railway yards and depots. This work involves obtaining 
                        regulatory approvals from the RSR across various stages, 
                        including concept development until actual construction. 
                        Additionally, we ensure timely updates to the business 
                        case, tender documentation, and procurement processes 
                        for contractor appointments while overseeing contract 
                        administration using the Joint Building Contracts 
                        Committee (JBCC) contract.
                    </p>
                </div>
            </div>

            <div class="card">
                <div class="img-container">
                    <img src={service_levelcrosing} alt="service"/>
                </div>
                <div class="card-content">  
                    <p>
                        Our company has actively participated in the preliminary 
                        and detailed design of a rail siding (Heavy Haul Track) 
                        covering approximately 10 kilometers. This project is a 
                        collaboration between a State-Owned Company and a 
                        mining company. Our responsibilities as project managers 
                        and engineering managers encompassed completing the 
                        detail design, railway specifications and construction 
                        methodology, creating four level crossing designs
                        according to RSR standard, risk assessments, Safety in 
                        Design (SiD), and Overhead Traction Equipment (OHTE).
                    </p>
                </div>
            </div>

            <div class="card">
                <div class="img-container">
                    <img src={service_1} alt="service"/>
                </div>
                <div class="card-content">  
                    <p>
                        Our firm has successfully conducted several Corridor 
                        Feasibility Studies focused on rapid rail systems. These 
                        studies leverage Public-Private Partnership (PPP) funding 
                        models as part of our Transaction Advisory services, 
                        adhering to national treasury guidelines. Our work 
                        encompasses operational planning, conceptual design of 
                        rail infrastructure, operating cost evaluations, and 
                        construction cost estimates. These assessments are 
                        informed by outputs from the Multimodal Transport 
                        Planning Software.
                    </p>
                </div>
            </div>
        </section>

    </div>
    );
}